'use strict';

import NS from 'src/ns';
import $ from 'jquery';
import expanded from 'src/utility/expanded';
import forEach from 'lodash/each';
import assign from 'lodash/assign';
import matchMedia from 'src/utility/matchMedia';

class AboutUs {
  constructor($target) {
    this.$block = $target;
    this.triggerButtonSelector = '[aria-controls*="stl-Expanded"]';
    this.expandedPanelSelector = '.stl-Item02__descriptionInner';
    this.ns = '.' + AboutUs.BEM.block;
  }

  init() {
    matchMedia.register('tablet', {
      onMatch: function() {
        this.changeMode(false);
      }.bind(this),
      onUnMatch: function() {
        this.changeMode(true);
      }.bind(this)
    });
  }

  changeMode(isMobile) {
    let $buttons = this.$block.find(this.triggerButtonSelector);
    let $panels = this.$block.find(this.expandedPanelSelector);

    forEach($buttons, (button) => {
      this.changeButtonState($(button), isMobile);
    });

    forEach($panels, (panel) => {
      let $panel = $(panel);

      expanded._changePanelState($panel, !isMobile);
      $panel.attr('style', '');
    });
  }

  changeButtonState($button, isMobile) {
    let isHidden = !isMobile;
    let isSelected = false;

    $button
      .attr('aria-hidden', isHidden)
      .attr('aria-selected', isSelected);
  }
}

assign(AboutUs, {
  BEM: {
    block: 'stl-AboutUs',
    element: {},
    modifier: {}
  },
  create: function(element) {
    const $target = element ? $(element): $('.' + AboutUs.BEM.block).first();

    if (!$target.length) return;

    new AboutUs($target).init();
  },
  createAll() {
    let $target = $('.' + AboutUs.BEM.block);

    if (!$target.length) return;

    forEach($target, (target) => {
      AboutUs.create(target);
    });
  }
});


export default NS.AboutUs = AboutUs;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/block/aboutUs.js